import { render, staticRenderFns } from "./ChallengeIntroPopup.vue?vue&type=template&id=2d1cdd0e&scoped=true"
import script from "./ChallengeIntroPopup.vue?vue&type=script&lang=js"
export * from "./ChallengeIntroPopup.vue?vue&type=script&lang=js"
import style0 from "./ChallengeIntroPopup.vue?vue&type=style&index=0&id=2d1cdd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1cdd0e",
  null
  
)

export default component.exports